import { watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useContactFormStore } from '../store/contactFormStore';
import { useContactListStore } from '../store/contactListStore';
import { IContactListQueryResult, IContactListItem } from '../utils/interfaces';

const getContactListItems = (apiData: IContactListQueryResult): IContactListItem[] | null => {
  const contactListItems = apiData?.data;
  return contactListItems ?? null;
}

export const useInitialiseContactList = () => {
  const contactFormStore = useContactFormStore();
  const contactListStore = useContactListStore();
  const { dataReady } = storeToRefs(contactFormStore);

  const getContactData = () => {
    const contactListApiUrl = contactFormStore.getContactListApiEndPoint ?? '';
    if (!contactListApiUrl) {
      contactListStore.apiError = true;
      return;
    }

    fetch(contactListApiUrl)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then((responseData) => {
        const contactListItems = getContactListItems(responseData);
        if (!contactListItems || !contactListItems.length) {
          contactListStore.dataError = true;
          return;
        }
        contactListStore.loadContactListItems(contactListItems);
      })
      .catch(() => {
        contactListStore.apiError = true;
      });
  };

  const stopContactFormDataWatcher = watch(dataReady, (newDataReady) => {
    if (newDataReady) {
      getContactData();
      stopContactFormDataWatcher();
    }
  }, { immediate: true });
};
